import type { RequestOptions } from "../common/server";
import type { AxShareConfigModel, ExtendedSsoResponse } from "@/generated/models";
import { server } from "./server";

export async function getConfig({ signal }: RequestOptions = {}) {
  const response = await server.get("user/getConfig", { signal });
  return await response.json() as AxShareConfigModel;
}

export async function getUserInfo({ signal }: RequestOptions = {}) {
  const response = await server.get("user/getUserInfo", { signal });
  return await response.json() as ExtendedSsoResponse;
}

export async function identify(_options: RequestOptions = {}) {
  await server.post("user/identify");
}
